module.exports = __webpack_public_path__ + "media/images/icons/outlined/export-85457471620b786eb2c0d402da761c35.svg";